/* RESPONSIBLE TEAM: team-phone */
import type HangUp from 'embercom/models/operator/visual-builder/step/hang-up';
import StepConfig, { type StepConfigParams } from '../step';

export default class HangUpConfiguration extends StepConfig {
  declare step: HangUp;

  constructor(params: Omit<StepConfigParams, 'component'> & { component?: string }) {
    super({
      component: 'workflows/graph-editor/node-items/steps/hang-up',
      ...params,
    });
  }

  get alignment() {
    return 'left' as const;
  }
}
